import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';
import { FC } from 'react';
const LoadingAlert: FC<AlertProps> = ({
  title = 'Loading',
  icon = 'loading',
  description = 'This is just a loading message, but we are so glad you are here!',
  ...props
}) => {
  return (
    <Alert
      intent="loading"
      title={title}
      icon={icon}
      description={description}
      {...props}
    />
  );
};
export default LoadingAlert;
